/* eslint-disable import/no-cycle */
import {getAgentSignature} from '../../helpers/getAgentSignature';
import {getHowToReadQuotesVideo} from '../../helpers/getHowToReadQuotesVideo';
import {QuoteTemplateParams} from '../quoteTemplateParams';
import {highlightYellow} from '../../helpers/highlightYellow';
import {getNextStepsVideo} from '../../helpers/getNextStepsVideo';
import {
    emailHeaderCompanyLogo,
    quoteGreeting,
    quoteDiscussionReview,
    quoteIntroVideo,
    quoteNextSteps,
    aboutAmplify,
    illnessBrochure,
} from '../../helpers/commonEmailComponents';

export default function quoteGULNonblend(params: QuoteTemplateParams) {
    const {name, face_amount: faceAmount, monthly_premium: monthlyPremium, brochureLink, illnessSection} = params;

    return `
${emailHeaderCompanyLogo}
<p>Hi ${highlightYellow(name)},</p>
${quoteGreeting}
${quoteDiscussionReview}
${quoteIntroVideo}
<p><strong>Our life insurance policies provide:</strong></p>
<ol>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Coverage that lasts for the rest of your life</span></li>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Pays out for life, critical, chronic, and terminal illness emergencies</span></li>
</ol>
<p><strong>Life insurance plan option for</strong><strong> </strong><strong>${highlightYellow(name)}</strong></p>
<ul>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">${highlightYellow(
        faceAmount,
    )}</span><span style="font-weight: 400;"> life, critical, chronic, and terminal illness protection for the rest of life (immediate payout in a life or qualifying health emergency)</span></li>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">${highlightYellow(
        monthlyPremium,
    )} per month</span></li>
</ul>
${getHowToReadQuotesVideo(params)}
${quoteNextSteps}
${getNextStepsVideo()}
${aboutAmplify}
${illnessBrochure(illnessSection, brochureLink)}
<p><span style="font-weight: 400;">Please let me know if you have any additional questions. Otherwise looking forward to speaking with you again </span><span style="font-weight: 400;">${highlightYellow(
        'on Friday',
    )}</span><span style="font-weight: 400;"> to help you find a plan that best fits your needs.</span></p>
<p><span style="font-weight: 400;">Sincerely,</span></p>
${getAgentSignature()}
	`;
}
